import { gridTpl } from '../../../../common/grid/grid.controller';

export const manufacturersGrid = {
    bindings: {
        onSelect: '&'
    },
    controller: 'ManufacturersGridController',
    ...gridTpl
};
